const FALLBACK = "Please check your email address. We weren't able to send an email there.";

/**
 * What the account page shows when `api/accounts/user/request-email-change`
 * fails. Both hosts answer a refusal they can explain, including a missing or
 * wrong current password (#1528), with 400 `{ message }`.
 */
export function emailChangeRefusalMessage(response: unknown): string {
    const data = (response as { data?: unknown } | null | undefined)?.data;
    const message = data && typeof data === 'object' ? (data as { message?: unknown }).message : undefined;

    return typeof message === 'string' && message.trim() ? message : FALLBACK;
}
